const tagsToReplace = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;"
};

const replaceTag = function(tag) {
  return tagsToReplace[tag] || tag;
};
const escapeHtml = function(str) {
  return (str || "").replace(/[&<>]/g, replaceTag);
};

export default escapeHtml;
